// Routes that guests can open without a session (legal CMS pages + public tasks).
export default function isPublicUnauthenticatedRoute(path = '') {
  // /{theme}/pages/{slug} — not static assets under /themes/...
  const isThemeCmsPage = /^\/(?!themes\/)[^/]+\/pages\//.test(path);
  const isPublicParticipantTask =
    path.includes('/participant/task/') && path.includes('/public');

  return isThemeCmsPage || isPublicParticipantTask;
}
